import { observable, action, _allowStateChangesInsideComputed } from "mobx";
import Autobind from "autobind-decorator";
import RootStore from "./rootStore";
import HotkeyModel from "models/hotkeyModel";
import Helper from "helper";
@Autobind
class HotkeyStore {
  // 다른 Store와 통신하기위해 사용
  _rootStore: RootStore;

  @observable
  _appliedHotkeys: Map<string, HotkeyModel>;
  _defaultHotkeys: Map<string, HotkeyModel>;

  @observable
  _appliedHandler: Map<string, any>;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    this._appliedHotkeys = new Map();
    this._defaultHotkeys = new Map();

    this._appliedHandler = new Map();
  }

  @action
  registerHotkeys(hotkeys: { [key: string]: any }) {
    for (let i = 0; i < hotkeys.length; i++) {
      const funcKey = hotkeys[i].name;
      let hasKeys = [...(this._appliedHotkeys.entries() as any)]
        .filter(({ 1: v }) => v.name === hotkeys[i].name)
        .map(([k]) => k);
      if (hasKeys.length > 0) {
        continue;
      }
      // 사전에 등록된 Hotkey중 동일한 sequence 가 있다면 삭제
      let appliedKeys = [...(this._appliedHotkeys.entries() as any)]
        .filter(({ 1: v }) => v.sequence === hotkeys[i].sequence)
        .map(([k]) => k);
      appliedKeys.forEach((key, i) => {
        this._appliedHotkeys.delete(key);
      });
      const model = new HotkeyModel(
        hotkeys[i].name,
        hotkeys[i].description,
        hotkeys[i].sequence,
        hotkeys[i].action
      );
      this._appliedHotkeys.set(funcKey, model);
    }
  }

  @action
  registerHandlers(handlers: { [key: string]: any }) {
    for (let i = 0; i < handlers.length; i++) {
      const handler = handlers[i].handler;
      const funcKey = handlers[i].funcKey;
      this._appliedHandler.set(funcKey, handler);
    }
  }

  @action
  setHandlers(handlers: { [key: string]: any }) {
    this._appliedHandler.clear();
    const keys = Object.keys(handlers);
    for (let i = 0; i < keys.length; i++) {
      const keyName = keys[i];
      const handler = handlers[keyName];
      this._appliedHandler.set(keyName, handler);
    }
  }

  @action
  setHotkeys(hotkeys: { [key: string]: HotkeyModel }) {
    const keys = Object.keys(hotkeys);
    for (let i = 0; i < keys.length; i++) {
      const keyName = keys[i];
      const name = hotkeys[keyName].name;
      const model = new HotkeyModel(
        hotkeys[keyName].name,
        hotkeys[keyName].description,
        hotkeys[keyName].sequence,
        hotkeys[keyName].action
      );
      this._appliedHotkeys.set(name, model);
    }
  }
  getHandlers() {
    let handlers: { [key: string]: Object } = {};
    this._appliedHandler.forEach((handler: any, key: string) => {
      handlers[key] = handler;
    });
    return handlers;
  }
  @action
  setDefaultHotkeys(hotkeys: any) {
    const keys = Object.keys(hotkeys);
    for (let i = 0; i < keys.length; i++) {
      const keyName = keys[i];
      const name = hotkeys[keyName].name;
      const model = new HotkeyModel(
        hotkeys[keyName].name,
        hotkeys[keyName].description,
        hotkeys[keyName].sequence,
        hotkeys[keyName].action
      );
      this._defaultHotkeys.set(name, model);
    }
  }

  getHotkeys() {
    let hotkeys: { [key: string]: Object } = {};
    this._appliedHotkeys.forEach((hotkey: HotkeyModel) => {
      const name = hotkey.name;
      const description = hotkey.description;
      const action = hotkey.action;
      const sequence = Helper.Validator.isArray(hotkey.sequence)
        ? hotkey.sequence.slice()
        : hotkey.sequence;
      hotkeys[name] = {
        name: name,
        description: description,
        sequence: sequence,
        action: action,
      };
    });
    return hotkeys;
  }

  getDefaultHotkeys() {
    let hotkeys: { [key: string]: Object } = {};
    this._defaultHotkeys.forEach((hotkey: HotkeyModel) => {
      const name = hotkey.name;
      const description = hotkey.description;
      const action = hotkey.action;
      const sequence = Helper.Validator.isArray(hotkey.sequence)
        ? hotkey.sequence.slice()
        : hotkey.sequence;
      hotkeys[name] = {
        name: name,
        description: description,
        sequence: sequence,
        action: action,
      };
    });
    return hotkeys;
  }

  getKeysFromCommandName(commandNames: [string] = [""]) {
    let result: { [key: string]: string } = {};
    commandNames.forEach((name: string) => {
      if (this._appliedHotkeys.has(name) === true) {
        const keyModel: any = this._appliedHotkeys.get(name);
        if (Helper.Validator.isDefined(keyModel) === true) {
          result[name] = keyModel.sequence;
        }
      } else {
        result[name] = "";
      }
    });
    return result;
  }
}

export default HotkeyStore;
